import SharedStorageAgentInterface from "../SharedStorageAgentInterface.js"

class SharedStorageAgentQiankun extends SharedStorageAgentInterface {
    constructor(qiankunMethodPromise, qiankunAppPromise, storageInitValue) {
        super();
        this.qiankunMethodPromise = qiankunMethodPromise;
        this.qiankunAppPromise = qiankunAppPromise;
        this.storageInitValue = storageInitValue;

        // set the storage initial value using the format expected by this agent
        this.storage = new Promise(async (resolve) => {
            const derefInitValue = structuredClone(storageInitValue);
            const initValue = {};
            for (const key in derefInitValue) {
                initValue[key] = await this._formatStorageValue(derefInitValue[key])
            }
            resolve(initValue);
        });
    }

    get = async (key=null) => {
        const resolvedStorage = await this.storage;
        if (key) {
            return resolvedStorage[key].value;
        }

        // if key is not specified
        // then extract the value of every storage key
        const parsedStorage = {};
        Object.keys(resolvedStorage).forEach(storageKey => {
            parsedStorage[storageKey] = this.get(storageKey);
        });
        return parsedStorage;
    }

    set = async (key, value) => {
        const resolvedStorage = await this.storage;
        // if the value was set by a different app (meaning, the global subscribe called this set method)
        // then just set the storage and do not update global state
        // WARNING: without this logic there a nasty infinite loop that will happen, because one app will set global which causes the other app to set global (goes back and forth)
        if (value?._set_by) {
            resolvedStorage[key] = value;
            return this;
        }

        // otherwise, this app called set first
        // so we need to set the storage and qiankun state
        resolvedStorage[key] = await this._formatStorageValue(value);
        const { setGlobalState } = await this.qiankunMethodPromise;
        setGlobalState(resolvedStorage);
        return this;
    }

    reset = async (key=null) => {
        // if key is provided
        // then just reset that one key
        if (key) {
            await this.set(key, this.storageInitValue[key]);
            return this;
        }

        // otherwise, reset all keys
        Object.keys(this.storageInitValue).forEach(storageInitValueKey => {
            this.set(storageInitValueKey, this.storageInitValue[storageInitValueKey]);
        });
        return this;
    }

    _formatStorageValue = async (value) => {
        const qiankunApp = await this.qiankunAppPromise;
        const formattedValue = {
            _set_by: qiankunApp,
            value: value
        }
        return formattedValue;
    }
}

export default SharedStorageAgentQiankun;